import type { NodeProps } from '@xyflow/react';
import { NodeShell } from './nodeShell';

export function TextNode({ data, selected }: NodeProps) {
  const d = data as { body?: string };
  return (
    <NodeShell title="Text" kind="text" accent="#555555" selected={selected}>
      <div style={{ whiteSpace: 'pre-wrap', fontSize: 11 }}>{d.body ?? ''}</div>
    </NodeShell>
  );
}
